var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"form-section-question",style:({
    '--size': (_vm.size + "px"),
    '--color': ("var(--v-navy-" + _vm.color + "-base)"),
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }